import { DashboardLayout } from "app/layout";
import { SettingOrgCreate } from "features/Setting";
import { FormikHelpers } from "formik";
import { StyledItem } from "pages/EmployeesProfile/style";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BackButton } from "shared/components/BackButton";
import { Button } from "shared/components/Button";
import { SETTINGORG } from "shared/consts/routingConsts";
import { closeModal, openModal } from "shared/redux/slice/modalSlice";

export const SettingOrgCreatePages = () => {
    const formikRef = useRef<FormikHelpers<any>>(null);

    const [loading, setLoading] = useState<boolean>(false);
    const [disabled, setDisabled] = useState<boolean>(true);


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleClick = (to: string) => {
        navigate(to);
    }

    const handleSaveClick = () => {
        if (formikRef.current) {
            formikRef.current.submitForm();
        }
    };

    const onDisabled = (disabled: boolean) => {
        setDisabled(disabled)
    }

    const handleCancelCreate = () => {
        dispatch(closeModal());
        navigate(SETTINGORG);
    }
    
    return (
        <DashboardLayout header={
            <div className="dashboard__header">
                <StyledItem>
                    <BackButton
                        text="Назад"
                        onClick={() => handleClick(SETTINGORG)}
                    />
                    <div className="dashboard__header-title">Создание организации</div>
                </StyledItem>
                <div className="dashboard__right-menu">
                    <Button bgLoading="white" loading={loading} onClick={handleSaveClick} disabled={disabled}>Сохранить</Button>
                    <Button 
                        themeType="outline-2" 
                        onClick={() => dispatch(openModal({
                            isOpen: true,
                            content: (
                                <>Вы точно хотите отменить создание?</>
                            ),
                            config: {
                                title: "Вы точно хотите отменить?",
                                btns: [
                                    {
                                        onClick: () => handleCancelCreate(),
                                        title: "Да",
                                        active: true
                                    },
                                    {
                                        onClick: () => dispatch(closeModal()),
                                        title: "Нет",
                                        active: false
                                    }
                                ]
                            }
                        }))}
                    >Отменить</Button>
                </div>
            </div>
        }>
            <SettingOrgCreate
                formikRef={formikRef}
                setDisabled={onDisabled}
                setLoading={setLoading}
            />
        </DashboardLayout>
    )
}